<template>
<div class="chapter">
<div class="inner_page">
<div class="pagebreak">
</div>
<h1 class="tocchaptitle"><a id="contents"></a><img alt="Image" src="images/U001.jpg"/> CONTENTS <img alt="Image" src="images/U002.jpg"/></h1>
<p class="toc1"><a href="#/04_chapter01#c1"><b>1. SOMETHING WICKED:</b></a></p>
<p class="toc1"><a href="#/04_chapter01#c1">Mysterious Objects and Haunted Homes</a></p>
<p class="toc1"><span href="#/05_chapter02#c2" title="Link target outside of Sample"><b>2. THE ANNUAL CHICKEN SHOW:</b></span></p>
<p class="toc1"><span href="#/05_chapter02#c2" title="Link target outside of Sample">Enchanted Animals, Psychic Pets, Botanical Oddities, <br/>and Other Strange Truths about Mother Nature</span></p>
<p class="toc1"><span href="#/06_chapter03#c3" title="Link target outside of Sample"><b>3. HISTORY'S MYSTERIES:</b></span></p>
<p class="toc1"><span href="#/06_chapter03#c3" title="Link target outside of Sample">Bizarre but True Facts about Historical Figures, <br/>and Oddities from Today and Yesterday</span></p>
<p class="toc1"><span href="#/07_chapter04#c4" title="Link target outside of Sample"><b>4. TENDER MURDERERS AND MALEVOLENT MALES:</b></span></p>
<p class="toc1"><span href="#/07_chapter04#c4" title="Link target outside of Sample">Killingly Good Tales of Terror</span></p>
<p class="toc1"><span href="#/08_chapter05#c5" title="Link target outside of Sample"><b>5. COINCIDENCE OR SYNCHRONICITY?</b></span></p>
<p class="toc1"><span href="#/08_chapter05#c5" title="Link target outside of Sample">Odd Things Happening to Ordinary Folks</span></p>
<p class="toc1"><span href="#/09_chapter06#c6" title="Link target outside of Sample"><b>6. MORBID WRITERS AND TORTURED ARTISTS:</b></span></p>
<p class="toc1"><span href="#/09_chapter06#c6" title="Link target outside of Sample">From Edgar Allan Poe to Vincent Van Gogh</span></p>
<p class="toc1"><span href="#/10_chapter07#c7" title="Link target outside of Sample"><b>7. DIA DE LOS MUERTOS:</b></span></p>
<p class="toc1"><span href="#/10_chapter07#c7" title="Link target outside of Sample">Corpses on Campus, Voices from Beyond the Grave, <br/>Strange Cemetery Facts, Spooky Specters, and Other<br/> Ghostly, Ghastly, and Gothic Goings On</span></p>
<p class="toc1"><span href="#/11_chapter08#c8" title="Link target outside of Sample"><b>8. SYMPATHY FOR THE DEVIL:</b></span></p>
<p class="toc1"><span href="#/11_chapter08#c8" title="Link target outside of Sample">Strange Rock-and-Roll Stories</span></p>
<p class="toc1"><span href="#/12_chapter09#c9" title="Link target outside of Sample"><b>9. STILL ON THE BOOKS (AND IN THE ETHER):</b></span></p>
<p class="toc1"><span href="#/12_chapter09#c9" title="Link target outside of Sample">Weirdest Laws in the World, Hoaxes, and Conspiracy Theories</span></p>
<p class="toc1"><span href="#/13_chapter10#c10" title="Link target outside of Sample"><b>10. PASSING STRANGE:</b></span></p>
<p class="toc1"><span href="#/13_chapter10#c10" title="Link target outside of Sample">Aberrations, Fascinating Phobias, and Odd Ancient Beliefs</span></p>
<p class="toc1"><span href="#/14_chapter11#c11" title="Link target outside of Sample"><b>11. THE VAPORS:</b></span></p>
<p class="toc1"><span href="#/14_chapter11#c11" title="Link target outside of Sample">Medical Maladies and Curious Cures</span></p>
<p class="toc1"><span href="#/15_chapter12#c12" title="Link target outside of Sample"><b>12. SUPERSTITIONS AND CURSES:</b></span></p>
<p class="toc1"><span href="#/15_chapter12#c12" title="Link target outside of Sample">To Hex, Lambast, and Bewitch</span></p>
<p class="toc1"><span href="#/16_chapter13#c13" title="Link target outside of Sample"><b>13. THE DARK SIDE OF THE MOON:</b></span></p>
<p class="toc1"><span href="#/16_chapter13#c13" title="Link target outside of Sample">UFO Stories and Bizarre and True Lunar Facts</span></p>
<p class="toc1"><span href="#/17_acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc1"><span href="#/18_biblogrpahy#biblo" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_contents.vue?5550052d